import type { CreateStyled } from '@emotion/styled';
import { startsWith } from 'lodash-es';

export const allowTransientProps: Parameters<CreateStyled>[1] = {
    shouldForwardProp: (propName: string) => !startsWith(propName, '$'),
};
